import React, { useRef, useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { FAQS } from '../faqs';
import { SectionHead } from './SectionHead';

export const Faq = () => {
  const [open, setOpen] = useState(() => new Set([0]));
  const refs = useRef([]);
  const toggle = (i) => setOpen((s) => {
    const n = new Set(s);
    if (n.has(i)) n.delete(i); else n.add(i);
    return n;
  });
  const onKey = (e, i) => {
    const last = FAQS.length - 1;
    const to = { ArrowDown: i === last ? 0 : i + 1, ArrowUp: i === 0 ? last : i - 1, Home: 0, End: last }[e.key];
    if (to === undefined) return;
    e.preventDefault();
    refs.current[to]?.focus();
  };

  return (
    <section className="mk-section mk-alt" id="faq" aria-labelledby="faq-title">
      <div className="mk-container">
        <SectionHead id="faq-title" eyebrow="FAQ" title="Questions, answered plainly" />
        <div className="mk-faq">
          {FAQS.map((f, i) => {
            const isOpen = open.has(i);
            return (
              <div key={f.q} className={`mk-faq-item ${isOpen ? 'open' : ''}`} data-testid="faq-item">
                <h3>
                  <button type="button" id={`faq-q-${i}`} ref={(el) => { refs.current[i] = el; }} aria-expanded={isOpen} aria-controls={`faq-a-${i}`}
                    onClick={() => toggle(i)} onKeyDown={(e) => onKey(e, i)} data-testid={`faq-question-${i}`}>
                    <span>{f.q}</span>
                    <ChevronDown size={18} aria-hidden="true" className="mk-caret" />
                  </button>
                </h3>
                <div id={`faq-a-${i}`} role="region" aria-labelledby={`faq-q-${i}`} className="mk-faq-panel" aria-hidden={!isOpen} data-testid={`faq-answer-${i}`}>
                  <div><p>{f.a}</p></div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
